import dayjs from "dayjs"
import weekOfYear from "dayjs/plugin/weekOfYear"
import isoWeek from "dayjs/plugin/isoWeek"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import isoWeeksInYear from "dayjs/plugin/isoWeeksInYear"
import isLeapYear from "dayjs/plugin/isLeapYear"

const plugin = () => {
  // 加載插件
  dayjs.extend(weekOfYear)
  dayjs.extend(isoWeek)
  dayjs.extend(utc)
  dayjs.extend(timezone)
  dayjs.extend(isoWeeksInYear)
  dayjs.extend(isLeapYear)
}

const timeZoneGMTMap: Record<string, string> = {
  "GMT+0": "Etc/GMT",
  "GMT+5": "Etc/GMT-5",
  "GMT+5:45": "Asia/Kathmandu",
  "GMT+6": "Etc/GMT-6",
  "GMT+7": "Etc/GMT-7",
  "GMT+8": "Etc/GMT-8",
  "GMT-4": "Etc/GMT+4",
  "GMT-7": "Etc/GMT+7",
  "GMT-11": "Etc/GMT+11"
}

// API (initInfo.timeZone) 可能回傳非 IANA 的時區縮寫，需對應到合法的 IANA 時區
const timeZoneAbbreviationMap: Record<string, string> = {
  IST: "Asia/Kolkata"
}

// 將 API 回傳的時區字串解析為合法的 IANA 時區
// 被 setTimezone 使用
const resolveTimeZone = (zone: string): string => {
  if (zone === "") return dayjs.tz.guess()

  return timeZoneGMTMap[zone] || timeZoneAbbreviationMap[zone] || zone
}

// 驗證時區字串是否為合法的 IANA 時區
// 被 setTimezone 使用，避免無效時區導致 RangeError (Sentry 9WICKET-CLIENT-28Q)
const isValidTimeZone = (zone: string): boolean => {
  try {
    Intl.DateTimeFormat(undefined, { timeZone: zone })
    return true
  } catch {
    return false
  }
}

// 由 useFetchInitInfo 呼叫，設定 dayjs 預設時區
const setTimezone = (zone: string) => {
  const resolved = resolveTimeZone(zone)

  if (isValidTimeZone(resolved)) {
    dayjs.tz.setDefault(resolved)
  } else {
    console.warn(
      `Invalid time zone "${zone}" (resolved: "${resolved}"), falling back to guessed timezone`
    )
    dayjs.tz.setDefault(dayjs.tz.guess())
  }
}

export { setTimezone, plugin }
export default plugin
